import { getFullLinks } from "application/functions";

export const links = getFullLinks({
  home: "/",
});
